export const getSelectionText = <TCurrent, TTotal>(currentSelections: TCurrent[], totalOptions: TTotal[]): string => {
  const current = currentSelections.length;
  const total = totalOptions?.length;
  if (total === 0) {
    return "";
  }
  return `${current.toLocaleString()} of ${total.toLocaleString()} item(s) selected`;
}
